import React from 'react';
import styled from 'styled-components';
import { Grid, Cell } from '../grid';

const PeopleGridContainer = styled.div`
  border-bottom: 1px solid #ebebeb;
`;

const PeopleGridInner = styled.div`
  max-width: 990px;
  margin: 0 auto;
  text-align: center;
  padding: 0 25px 100px;
`;

const Name = styled.div`
  padding-top: 20px;
  padding-bottom: 8px;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 20px;
`;

const JobTitle = styled.div`
  color: #666666;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;

const ImageContainer = styled.div`
  border-radius: 6px;
  overflow: hidden;
  /* box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1); */
  border: 1px solid rgba(0, 0, 0, 0.1);
  img {
    width: 100%;
    display: block;
  }
`;

function PeopleGridSection({ input }) {
  return (
    <PeopleGridContainer>
      <PeopleGridInner>
        <Grid columns={6} columnGap={'30px'} rowGap={'52px'}>
          {input.items.map((item, i) => {
            return (
              <Cell key={i} xs={3} sm={2}>
                {item.image && item.image.url &&
                  <ImageContainer><img src={item.image.url} /></ImageContainer>
                }
                <Name>{item.person_name.text}</Name>
                <JobTitle>{item.person_title.text}</JobTitle>
              </Cell>
            );
          })}
        </Grid>
      </PeopleGridInner>
    </PeopleGridContainer>
  );
}

export { PeopleGridSection };
